import { Stack } from '@mui/material';
import { FC } from 'react';
import Loader from '../loader';

const LoadingOverlay: FC = () => {
  return (
    <Stack direction="row" height="100%" width="100%" alignItems="flex-start" pt={1}>
      <Loader />
    </Stack>
  );
};

export default LoadingOverlay;
